// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2ZYd6","colored":"style_colored__Iyv-R","isSticky":"style_isSticky__2SMn8","menu":"style_menu__f52kh"};